// removed by extract-text-webpack-plugin
module.exports = {"root":"_3nOjH","card":"_2Ieir","content":"_23Qcw","heading":"_1VKU5","description":"_1MYQu","resend":"_2OKk-","resendText":"_1hsj-","disabled":"_2yGJ2","counter":"_1HfcQ","troubleHint":"_2TDFU","hintText":"_10UCs","illustration":"_z7R9K"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Login/components/EmailNotVerified/EmailNotVerified.scss
// module id = 1174
// module chunks = 15